import React, {Component} from 'react'
import {Query, Mutation} from 'react-apollo'
import {Button, Modal, ModalHeader, ModalBody, Input, Label, FormGroup} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from "react-toastify";
import groupBy from 'lodash/groupBy'

import UserExpenseList from "./UserExpenseList"
import query from '../../../queries/server/user_project_expenses'
import Loading from "../Loading";
import ProjectExpenseInput from "../project/ProjectExpenseInput";
import AUSelectGenerator from "../auto_updaters/Select";

import upsertUserExpenseMutation from '../../../queries/server/mutations/upsert_user_expense'
import projectExpenseQuery from "../../../queries/server/project_expense";
import userExpensesLocalMutation from '../../../queries/client_side/mutations/edit_user_expenses'
import deleteUserExpensesLocalMutation from '../../../queries/client_side/mutations/remove_user_project_expense'
import {checkPermission, EXPENSES_CAN_VIEW_OTHER_USERS_EXPENSES} from "../../../lib/permissions";

const AUSelectUsers = AUSelectGenerator('filter_users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'], [{
    key: 'active',
    value: 1
}])

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

export default class UserExpenses extends Component {



    constructor(props){
        super(props)
        this.state = {
            showInput: false,
            showEdit: false,
            expenseID: null,
            selectedUserID: props.user_id,
            showPaidExpenses: 0
        }
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    toggleEdit = (id) => {
        this.setState({showEdit: !this.state.showEdit, expenseID: id})
    }

    render() {

        const {toggle, toggleEdit} = this
        const {showInput, expenseID, showEdit, showPaidExpenses} = this.state

        const selectedUserID = (this.state.selectedUserID) ? this.state.selectedUserID : null

        return (
            <Mutation mutation={deleteUserExpensesLocalMutation}>
                {(deleteUserExpensesLocalMutationFunc) => (
                    <Mutation mutation={userExpensesLocalMutation}>
                        {(userExpensesLocalMutationFunc) => (
                            <Mutation mutation={upsertUserExpenseMutation}>
                                {(upsertUserExpenseMutationFunc, upsertUserExpenseMutationObj) => (
                                    <Query query={query} fetchPolicy="network-only" variables={{user_id: selectedUserID, is_paid: showPaidExpenses}}>
                                        {(({data, loading}) => {

                                            if (loading) return <Loading/>

                                            const userGroup = groupBy(data.user_project_expenses, ({user, user_id}) => `${user_id} - ${user.full_name}`)

                                            return (<div className="d-flex flex-column">
                                                <div
                                                    className="d-flex p-3 justify-content-between flex-row align-items-center">
                                                    <h1>Expenses</h1>
                                                    {checkPermission(EXPENSES_CAN_VIEW_OTHER_USERS_EXPENSES) && <div className="d-flex flex-row">
                                                    <FormGroup>
                                                        <Label for="user_id">User</Label>
                                                        <AUSelectUsers
                                                            defaultLabel="All Users"
                                                            id="user_id"
                                                            bsSize="sm"
                                                            value={selectedUserID}
                                                            onChange={(selectedUserID) => this.setState({selectedUserID})}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup className="pl-3">
                                                        <Label for="paid_status">Paid Status</Label>
                                                        <Input id="paid_status" size="sm" type="select" value={showPaidExpenses} onChange={(evt) => this.setState({showPaidExpenses: evt.target.value || null})}>
                                                            <option value="">Show All</option>
                                                            <option value={0}>Outstanding</option>
                                                            <option value={1}>Paid</option>
                                                        </Input>
                                                    </FormGroup>
                                                    </div>}
                                                    <div className="d-flex flex-column">
                                                        <Button
                                                            size="sm"
                                                            color={showInput ? 'warning' : 'success'}
                                                            onClick={toggle}
                                                        >
                                                            <FontAwesomeIcon color="#fff"
                                                                             icon={showInput ? 'minus' : 'plus'}/>{' '}
                                                            {showInput ? 'Cancel' : 'Add Expense'}
                                                        </Button>
                                                    </div>

                                                </div>
                                                <div className="p-3">
                                                    {Object.keys(userGroup).map(full_name => {

                                                        const totalExpenses = userGroup[full_name].reduce((carry, {gross}) => {
                                                            carry += gross
                                                            return carry
                                                        }, 0)

                                                        return (
                                                            <div>
                                                                <div className="d-flex flex-row justify-content-between">
                                                                    <h4 className="p-0 m-0 pt-2">{userGroup[full_name][0].user.full_name}</h4>
                                                                    <h4 className="p-0 m-0 pt-2">{format(totalExpenses)}</h4>
                                                                </div>
                                                                <UserExpenseList
                                                                    data={userGroup[full_name]}
                                                                    onDownload={(url) => window.open(url)}
                                                                    onEdit={(id) => {
                                                                        this.setState({showEdit: true, expenseID: id})
                                                                    }}
                                                                    onDelete={(id) => {
                                                                        toast.success('Expense Removed', {autoClose: 2000})

                                                                        deleteUserExpensesLocalMutationFunc({
                                                                            variables: {
                                                                                id,
                                                                                user_id: selectedUserID,
                                                                                is_paid: showPaidExpenses
                                                                            }
                                                                        })
                                                                    }}
                                                                />
                                                            </div>
                                                            )
                                                    })}
                                                    
                                                </div>

                                                <ProjectExpenseInput
                                                    isOpen={showInput}
                                                    toggle={toggle}
                                                    label="Create Expense"
                                                    loading={false}
                                                    saving={upsertUserExpenseMutationObj.loading}
                                                    onSave={({user_id, expense_at, destination, description, expense_type, vat, gross, paid_at, file, project_id}) => {

                                                        upsertUserExpenseMutationFunc({
                                                            variables: {
                                                                data: {
                                                                    project_id,
                                                                    user_id,
                                                                    expense_at,
                                                                    destination,
                                                                    description,
                                                                    expense_type,
                                                                    net: (gross || 0) - (vat || 0),
                                                                    vat,
                                                                    gross,
                                                                    paid_at,
                                                                    file
                                                                }
                                                            }
                                                        })
                                                            .then(({data}) => {
                                                                toast.success('Expense Created', {autoClose: 2000})
                                                                this.toggle()

                                                                userExpensesLocalMutationFunc({
                                                                    variables: {
                                                                        data: data.upsertUserExpense,
                                                                        user_id: selectedUserID,
                                                                        is_paid: showPaidExpenses
                                                                    }
                                                                })
                                                            })
                                                    }}
                                                />

                                                {expenseID && showEdit &&
                                                <Query query={projectExpenseQuery} fetchPolicy="network-only"
                                                       variables={{id: expenseID}} skip={!expenseID}>
                                                    {({data, loading}) => {

                                                        if (loading) return (
                                                            <Modal isOpen={showEdit}>
                                                                <ModalHeader>Edit Expense</ModalHeader>
                                                                <ModalBody>
                                                                    <Loading/>
                                                                </ModalBody>
                                                            </Modal>
                                                        )

                                                        return (
                                                            <ProjectExpenseInput
                                                                isOpen={showEdit}
                                                                toggle={toggleEdit}
                                                                label="Edit Expense"
                                                                loading={loading}
                                                                saving={upsertUserExpenseMutationObj.loading}
                                                                {...data.project_expense}
                                                                onSave={({id, user_id, expense_at, destination, description, expense_type, vat, gross, paid_at, file, project_id}) => {
                                                                    upsertUserExpenseMutationFunc({
                                                                        variables: {
                                                                            data: {
                                                                                id,
                                                                                project_id,
                                                                                user_id,
                                                                                expense_at,
                                                                                destination,
                                                                                description,
                                                                                expense_type,
                                                                                net: (gross || 0) - (vat || 0),
                                                                                vat,
                                                                                gross,
                                                                                paid_at,
                                                                                file,
                                                                                file_path: data.project_expense.file_path
                                                                            }
                                                                        }
                                                                    })
                                                                        .then(({data}) => {
                                                                            toast.success('Expense Updated', {autoClose: 2000})
                                                                            this.toggleEdit()

                                                                            userExpensesLocalMutationFunc({
                                                                                variables: {
                                                                                    data: data.upsertUserExpense,
                                                                                    user_id: selectedUserID,
                                                                                    is_paid: showPaidExpenses
                                                                                }
                                                                            })
                                                                        })
                                                                }}
                                                            />
                                                        )
                                                    }}


                                                </Query>}

                                            </div>)
                                        })}

                                    </Query>
                                )}

                            </Mutation>
                        )}

                    </Mutation>
                )}

            </Mutation>
        )

    }

}